import { api } from "@lib/orpc-client"
import useSWR from "swr"

const useReferralJourney = () => {
    const { data, isLoading, error } = useSWR(
        'walletV2.referral.journey',
        () => api.walletV2.referral.journey({})
    )

    return {
        data,
        isLoading,
        error
    }
}

export default useReferralJourney
